{
  "pages.title": "Pages",
  "pages.description": "A place for your pages, plans, and connected work.",
  "pages.disabled": "Pages is currently disabled. Your existing workspaces are available.",
  "pages.back_planner": "Open Planner",
  "pages.tree": "Your pages",
  "pages.favorites": "Favorites",
  "pages.private_pages": "Private pages",
  "pages.recent": "Recent pages",
  "pages.sidebar_empty": "No pages yet. Use + to create your first page.",
  "pages.archive_empty": "No archived pages.",
  "pages.open_sidebar": "Open page navigation",
  "pages.close_sidebar": "Close page navigation",
  "pages.from_template": "Create from template",
  "pages.remove_favorite": "Remove from favorites",
  "pages.move_to_page": "Move to another page",
  "pages.destination_page": "Destination page",
  "pages.select_page": "Select a page",
  "pages.new_page": "New page",
  "pages.new_subpage": "New subpage",
  "pages.search_pages": "Find a page…",
  "pages.home": "Home page",
  "pages.open_home": "Open my home page",
  "pages.show_archive": "Archived pages",
  "pages.hide_archive": "Hide archived pages",
  "pages.experimental": "Experimental workspace",
  "pages.welcome": "A place that takes your shape.",
  "pages.welcome_body": "Start a page, write freely, and use / to add real tasks, plans, projects, and tools. Your existing workspaces stay connected.",
  "pages.first_page": "Create your first page",
  "pages.name": "Title",
  "pages.untitled": "Untitled page",
  "pages.template": "Start with",
  "pages.template.blank": "Empty page",
  "pages.template.project": "Project and plan workspace",
  "pages.template.life": "Life tracking",
  "pages.template.project_heading": "What I am working on",
  "pages.template.life_heading": "Things I want to notice",
  "pages.create": "Create",
  "pages.move_page": "Move page",
  "pages.parent_page": "Under this page",
  "pages.root": "At the top level",
  "pages.move": "Move",
  "pages.expand": "Expand subpages",
  "pages.favorite": "Favorite",
  "pages.set_home": "Use as home page",
  "pages.archive": "Archive",
  "pages.restore": "Restore",
  "pages.page_actions": "Page actions",
  "pages.breadcrumb": "Page path",
  "pages.source": "Source",
  "pages.visual": "Document",
  "pages.history": "History",
  "pages.duplicate": "Duplicate",
  "pages.copy_suffix": "(copy)",
  "pages.recovered_draft": "An unsaved draft from this account was recovered. Review it before saving.",
  "pages.keep_draft": "Keep my draft",
  "pages.discard_draft": "Discard draft",
  "pages.conflict_detail": "The saved document or a linked record changed. Your draft is preserved; load the current version before applying a new edit.",
  "pages.load_server": "Load saved version",
  "pages.retry": "Try again",
  "pages.archived_notice": "This page is archived.",
  "pages.subtasks": "Subtasks",
  "pages.add_subtask": "Add subtask",
  "pages.source_hint": "Edit ExoDoc source, then apply once. Reading or typing source does not run domain actions.",
  "pages.source_label": "ExoDoc source",
  "pages.source_pending": "Apply or discard the source draft before switching back.",
  "pages.source_target_mismatch": "This source belongs to another document or revision, or is incomplete. Read a complete current source before replacing this page.",
  "pages.discard_source": "Discard source changes",
  "pages.apply": "Apply",
  "pages.backlinks": "Linked from",
  "pages.upload": "Attach a file",
  "pages.page_link": "Page link",
  "pages.history_hint": "Restoring a document revision changes its content and layout. Linked tasks and other records keep their current state.",
  "pages.revision_restored": "Document revision restored",
  "pages.media_retry": "The document is ready. Select the file again to attach it.",
  "pages.task_trashed": "Task moved to Trash",
  "pages.task_trash_detail": "The real task is in Trash. Its subtasks keep their own state.",
  "pages.save_error": "The changes could not be saved.",
  "pages.load_error": "This content could not be loaded.",
  "pages.loading": "Loading…",
  "pages.saved": "Saved",
  "pages.dirty": "Unsaved changes",
  "pages.saving": "Saving…",
  "pages.offline": "Offline · draft preserved",
  "pages.error": "Could not save",
  "pages.conflict": "Changes need review",
  "pages.source_draft": "Source draft · not applied",
  "pages.search_more": "Narrow your search to find more pages.",
  "pages.entity_composer": "Add a connected record",
  "pages.entity_type": "Record type",
  "pages.create_new": "Create new",
  "pages.link_existing": "Link existing",
  "pages.search_entities": "Search records",
  "pages.no_results": "No results",
  "pages.description_field": "Description",
  "pages.note_content": "Note content",
  "pages.start_date": "Start date",
  "pages.end_date": "End date",
  "pages.frequency": "Repeat",
  "pages.daily": "Daily",
  "pages.weekly": "Weekly",
  "pages.create_and_insert": "Create and add to page",
  "pages.creation_unavailable": "This type can be linked here. Its creation requires its own domain workflow.",
  "pages.subtask_context": "The new task will be a real subtask of the open task.",
  "pages.plan_context": "The new task will belong to this plan.",
  "pages.project_context": "The new task will belong to this project.",
  "pages.paragraph": "Text",
  "pages.heading1": "Heading 1",
  "pages.heading2": "Heading 2",
  "pages.bullet": "Bullet list",
  "pages.numbered": "Numbered list",
  "pages.checklist": "Local checklist",
  "pages.toggle": "Toggle section",
  "pages.toggle_title": "Toggle title",
  "pages.quote": "Quote",
  "pages.divider": "Divider",
  "pages.code": "Code block",
  "pages.table": "Content table",
  "pages.columns2": "Two columns",
  "pages.columns3": "Three columns",
  "pages.image": "Image",
  "pages.file": "File",
  "pages.focus": "Focus timer",
  "pages.editor_placeholder": "Write, or type / to add a block…",
  "pages.editor_label": "Page content",
  "pages.formatting": "Text formatting",
  "pages.add_block": "Add a block",
  "pages.bold": "Bold",
  "pages.italic": "Italic",
  "pages.link": "Link",
  "pages.link_url": "Link address",
  "pages.move_up": "Move block up",
  "pages.move_down": "Move block down",
  "pages.undo": "Undo",
  "pages.redo": "Redo",
  "pages.add_row": "Add row",
  "pages.add_column": "Add column",
  "pages.close": "Close",
  "pages.block_actions": "Block actions",
  "pages.unlink": "Remove from this page only",
  "pages.trash_task": "Move the real task to Trash",
  "pages.complete_task": "Complete task",
  "pages.entity_unavailable": "Linked record unavailable",
  "pages.unknown_block": "This block uses an unsupported version. Its content is preserved.",
  "pages.view": "View",
  "pages.view.tasks": "Tasks",
  "pages.view.saved": "Saved view",
  "pages.view.calendar": "Calendar",
  "pages.view.life": "Life table",
  "pages.view.empty": "Nothing here yet. Add a task or change the view.",
  "pages.view.configure_life": "Choose a life table to show its real records.",
  "pages.live_view": "Live view · results are not copied into the document",
  "pages.new_task": "New task",
  "pages.new_row": "New record",
  "pages.more": "Load more",
  "pages.date": "Date",
  "pages.calendar.day": "Day",
  "pages.calendar.week": "Week",
  "pages.calendar.month": "Month",
  "pages.calendar.year": "Year",
  "pages.media_unavailable": "This attachment could not be previewed.",
  "pages.download": "Download",
  "pages.field.description": "Description",
  "pages.details": "Details",
  "pages.field.content": "Original note content",
  "pages.field.start_date": "Start",
  "pages.field.end_date": "End",
  "pages.field.target_date": "Target date",
  "pages.field.priority": "Priority",
  "pages.field.estimate_minutes": "Estimate (minutes)",
  "pages.priority.low": "Low",
  "pages.priority.normal": "Normal",
  "pages.priority.high": "High",
  "pages.status.pending": "Pending",
  "pages.status.active": "Active",
  "pages.status.completed": "Completed",
  "pages.status.cancelled": "Cancelled",
  "pages.status.skipped": "Skipped",
  "pages.status.trashed": "In Trash",
  "pages.status.archived": "Archived",
  "pages.status.draft": "Draft",
  "pages.entity.task": "Task",
  "pages.entity.project": "Project",
  "pages.entity.plan": "Plan",
  "pages.entity.routine": "Routine",
  "pages.entity.span": "Period",
  "pages.entity.period": "Period",
  "pages.entity.note": "Note",
  "pages.entity.life_area": "Life area",
  "pages.entity.life_schema": "Life table",
  "pages.entity.life_item": "Life record",
  "pages.entity.knowledge_item": "Knowledge",
  "pages.entity.knowledge_map": "Knowledge map",
  "pages.entity.goal": "Goal",
  "pages.entity.decision": "Decision",
  "pages.entity.rationale": "Rationale",
  "pages.entity.moment": "Journal entry",
  "pages.entity.work_session": "Work session",
  "pages.entity.focus_session": "Focus session",
  "pages.entity.saved_view": "Saved view",
  "pages.table_context": "The record is added to the selected table.",
  "pages.frequency.daily": "Every day",
  "pages.frequency.times_per_week": "A number of times per week",
  "pages.frequency.every_x_days": "Every several days",
  "pages.frequency_count": "Frequency count / interval",
  "pages.life_section": "Life section",
  "pages.life_section.tracking": "Tracking",
  "pages.life_section.guide": "Guide",
  "pages.select_area": "Choose a Life area",
  "pages.select_table": "Choose a published table",
  "pages.schema_kind": "Table kind",
  "pages.schema_kind.record": "Record",
  "pages.schema_kind.entity": "Entity",
  "pages.schema_kind.guide_entry": "Guide entry",
  "pages.time_mode": "Time field",
  "pages.time_mode.none": "None",
  "pages.time_mode.date": "Date",
  "pages.time_mode.instant": "Date and time",
  "pages.time_mode.interval": "Time interval",
  "pages.device_timezone": "Time zone: {{zone}} (this device)",
  "pages.template.preview.blank": "Creates an empty text page.",
  "pages.template.preview.project": "Applying creates a real project and plan, then adds their task view and a focus tool.",
  "pages.template.preview.life": "Applying creates a real Life area and a dated record table. No rows are created yet.",
  "pages.unsaved_navigation": "You have an unsaved draft. It is retained for this account if you leave.",
  "pages.stay": "Stay here",
  "pages.leave": "Keep draft and leave",
  "pages.read_only_entity": "This record is in Trash or read only. You can view its content.",
  "pages.old_view": "Open original view",
  "pages.columns_ratio": "Column ratio",
  "pages.command_group.writing": "Writing blocks",
  "pages.command_group.records": "Real records",
  "pages.command_group.media": "Pages and files",
  "pages.command_group.tools": "Views and tools",
  "pages.link_placeholder": "https://example.com",
  "pages.drag_block": "Drag block or use Alt + arrow keys"
}
